type Props = {
  title: string;
  description: string;
};

export default function MomentHeaderCard({ title, description }: Props) {
  return (
    <div className="tw-relative tw-overflow-hidden tw-bg-white tw-border tw-border-gray-200 tw-rounded-2xl tw-p-8 tw-text-gray-900 tw-shadow-sm">
      <div className="tw-relative tw-flex tw-items-center tw-justify-between">
        <div>
          <h1 className="tw-text-2xl tw-font-bold tw-mb-1">{title}</h1>
          <p className="tw-text-gray-500 tw-text-sm">{description}</p>
        </div>
      </div>
    </div>
  );
}
